import { ResetReason } from '@/task-manager/entities/reset-reason';

type ReasonEnum = 'maintenance' | 'recalibration' | 'replacement' | 'other';

export function resetReasonMapper(data: ResetReason): ReasonEnum {
  switch (data) {
    case ResetReason.MAINTENANCE:
      return 'maintenance';
    case ResetReason.RECALIBRATION:
      return 'recalibration';
    case ResetReason.REPLACEMENT:
      return 'replacement';
    default:
      return 'other';
  }
}
